import React, { useCallback } from 'react'
import { Box, Grid, Typography } from '@material-ui/core'

import { PageTitle } from 'Components/PageTitle'
import { CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE } from '../../../../shared/constants'

import { EmptyStateSimpleBtn } from '../CampaignEmptyStateButtons'
import EmptyStateMessage from '../EmptyStateMessage'
import D2DEmptyState from '../../../../Assets/Images/icons/d2dEmptyState'

const CampaignEmptyStateAIM = ({
  classes,
  isSelfServeEnabled,
  handleCreateCampaign,
  validRoute,
  enabledChannel,
  route,
}) => {
  const handleClick = useCallback(async () => {
    await handleCreateCampaign()
  }, [handleCreateCampaign])

  return (
    <React.Fragment>
      {!enabledChannel && (
        <EmptyStateMessage title="Sorry, this channel is currently not available to be created through platform" />
      )}
      <Box className={classes.campaignWrapper}>
        <PageTitle className={classes.title}>
          {CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE[route]}
        </PageTitle>
        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm={7}>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <p className={classes.emptyStateText}>
                With Promofy’s insert campaigns, your flyers are placed directly
                into packages shipped by trusted vendors, ensuring high
                visibility and tangible impact.
              </p>
              <p className={classes.emptyStateText}>
                Simply reach out to one of our experts to start planning your
                campaign. We'll handle the printing, logistics, and vendor
                coordination for you.
              </p>
              <p className={classes.emptyStateText}>
                From shipment to delivery. Insert campaigns offer a smart,
                scalable way to connect with engaged customers at the perfect
                moment—when they’re already receiving something they care about.
              </p>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} className="text-center">
            <D2DEmptyState />
          </Grid>
        </Grid>
        {validRoute && enabledChannel && (
          <Box className={classes.btnWrapper}>
            <Typography className={classes.btnTitle}>
              Let's create your first campaign!
            </Typography>
            {isSelfServeEnabled && (
              <EmptyStateSimpleBtn classes={classes} onClick={handleClick} />
            )}
          </Box>
        )}
      </Box>
    </React.Fragment>
  )
}

export default CampaignEmptyStateAIM
